import { render, staticRenderFns } from "./ManageChats.vue?vue&type=template&id=78102a2a&scoped=true"
import script from "./ManageChats.vue?vue&type=script&lang=js"
export * from "./ManageChats.vue?vue&type=script&lang=js"
import style0 from "./ManageChats.vue?vue&type=style&index=0&id=78102a2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78102a2a",
  null
  
)

export default component.exports